export enum LocalRoutes {
    AGENCY_LIST = '/agency',
    PARTNER_LIST = '/partner/partners',
    PARTNER_CREATE = '/partner/campaign/form/',
    COMPANY_EDIT = '/company/edit/',
    COMPANY_GROUP_EDIT = '/company/groups/',
    VERIFICATION = 'verification-page',
}
